export const DEFAULT_TIME_ZONE = 'Europe/Berlin';
